const getQueryErrorInvalidFormat = (): string => {
  return "Ошибка: не удалось распознать формат ответа. Ожидаемый формат: JSON";
};

export default getQueryErrorInvalidFormat;
